import { NgModule } from '@angular/core';
import { CurrencyPipe } from '@angular/common';
import { GooglePlacesDirective } from '@deltager/organizers/admin/shared/directives/google-places.directive';
import { ControlSyncDirective } from './directives/control-sync.directive';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { provideNgxMask } from 'ngx-mask';
import { DigitOnlyDirective } from '@deltager/organizers/admin/shared/directives/digit-only-input.directive';

@NgModule({
  declarations: [GooglePlacesDirective, ControlSyncDirective, DigitOnlyDirective],
  imports: [],
  exports: [GooglePlacesDirective, ControlSyncDirective, DigitOnlyDirective],
  providers: [CurrencyPipe, { provide: MAT_DATE_LOCALE, useValue: 'en-GB' }, provideNgxMask()],
})
export class DirectivesModule {
  static forRoot() {
    return {
      ngModule: DirectivesModule,
      imports: [],
      exports: [],
    };
  }
}
